var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLgbt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35566_19851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8155 0C7.55188 0 7.33534 0.216543 7.33534 0.480161C7.33534 0.743779 7.55188 0.960323 7.8155 0.960323H8.35215L6.37501 2.93746C5.7348 2.41022 4.9157 2.09953 4.02128 2.09953C1.96883 2.09953 0.292969 3.77539 0.292969 5.83726C0.292969 7.73907 1.71462 9.30195 3.55053 9.53732V11.8157H2.61846C2.35484 11.8157 2.12888 12.0229 2.11946 12.2865C2.11005 12.5595 2.33601 12.7761 2.59963 12.7761H3.55053V13.5104C3.55053 13.774 3.75766 14 4.02128 14.0094C4.29431 14.0188 4.51086 13.7929 4.51086 13.5293V12.7855H5.44293C5.70655 12.7855 5.93251 12.5783 5.94193 12.3147C5.95134 12.0417 5.72538 11.8252 5.46176 11.8252H4.51086V9.54674C6.34677 9.30195 7.76842 7.72966 7.76842 5.83726C7.76842 5.01816 7.49539 4.25555 7.04347 3.63416L9.03944 1.6382V2.05245C9.03944 2.31607 9.24657 2.54203 9.51018 2.55145C9.78322 2.55145 9.99976 2.3349 9.99976 2.07128V0.414257C9.99976 0.178884 9.81146 0 9.5855 0H7.8155ZM4.0307 8.61466C2.49606 8.61466 1.25329 7.37189 1.25329 5.83726C1.25329 4.30262 2.49606 3.05985 4.0307 3.05985C5.56533 3.05985 6.8081 4.30262 6.8081 5.83726C6.8081 7.36247 5.55591 8.61466 4.0307 8.61466Z",
    fill: "#C778FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35566_19851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.70679,
    height: 14,
    fill: "white",
    transform: "translate(0.292969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgbt);
export default __webpack_public_path__ + "static/media/lgbt.be57166e.svg";
export { ForwardRef as ReactComponent };